import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { I18nContext } from "../../../store/context/i18nContext";
import { SelectField } from "../../SelectField/SelectField";
import CountrySelectService from "./CountrySelectService";

const CountrySelectCyclos = ({
  isd,
  isoCode,
  noLabel,
  innerContainerClassName,
  innerContainerStyle,
  containerStyle,
  error,
  inputGroup,
  style,
  name,
  plain,
  placeholder,
  className,
  onChange,
  value,
  showErr,
  outline,
  inline,
  borderNone,
  RightComponent,
  onClickRight,
  label,
  required,
  showClear,
  noIP,
  dropDownMenuWidth,
  ...props
}) => {

  const [COUNTRIES, setCountries] = useState([]);
  const { t } = useContext(I18nContext);


  useEffect(() => {
    const fetch = async () => {
      try {
        await CountrySelectService.fetchCyclosCountryMaster();
        setCountries(
          toJS(CountrySelectService.cyclosCountryMaster)
            .filter((country) => !isd || Boolean(country?.isdCodes?.length || country?.isd))
            .flatMap((country) => {
              const dialCodes = isd
                ? (country?.isdCodes?.length ? country.isdCodes : country?.isd ? [country.isd] : [])
                : [country?.isd];

              return dialCodes.map((dialCode) => ({
                ...country,
                isd: dialCode || country?.isd,
                value: isd ? (dialCode || country?.isd) : isoCode ? country?.isoCode2 : country?.value,
                label: isd || isoCode
                  ? `${dialCode || country?.isd ? `+${dialCode || country?.isd} ` : ""}${country?.label} (${country?.isoCode2})`
                  : country?.label,
              }));
            })
        );
      } catch (error) {
      }
    };
    fetch();
  }, [isd, isoCode]);

  const filterOption = useCallback((option, inputValue) =>
    !inputValue ||
    ["value", "label"]?.some(
      key =>
        `${option.data[key]}`?.toLowerCase().includes(inputValue.toLowerCase())
    ),
    []);

  return (
    <React.Fragment>
      {COUNTRIES.length > 0 && (

        <SelectField
          filterOption={filterOption}
          showClear={showClear}
          key={value}
          label={label ? label : t("Country")}
          error={
            error
          }
          required={required}
          containerStyle={containerStyle}
          data={COUNTRIES}
          inputGroup={inputGroup}
          innerContainerStyle={innerContainerStyle}
          innerContainerClassName={innerContainerClassName}
          placeholder={placeholder ?? ""}
          noLabel={noLabel}
          style={style}
          plain={plain}
          className={className}
          onChange={onChange}
          value={value }
          outline={outline}
          showErr={showErr}
          inline={inline}
          borderNone={borderNone}
          RightComponent={RightComponent}
          onClickRight={onClickRight}

          {...props}
        />
      )}

      {!(COUNTRIES?.length > 0) && (
        <SelectField
          filterOption={filterOption}
          showClear={showClear}
          label={label ? label : t("Country")}
          isDisabled={true}
          error={
            error
          }
          containerStyle={containerStyle}
          data={COUNTRIES}
          inputGroup={inputGroup}
          id={props.id}
          data-testid={props["data-testid"]}
          dropDownMenuWidth={dropDownMenuWidth}
          innerContainerStyle={innerContainerStyle}
          innerContainerClassName={innerContainerClassName}
          className={className}
          placeholder={placeholder ?? ""}
          noLabel={noLabel}
          style={style}
          plain={plain}
          onChange={onChange}
          value={value}
          outline={outline}
          showErr={showErr}
          inline={inline}
          borderNone={borderNone}
          RightComponent={RightComponent}
          onClickRight={onClickRight}
        />
      )}
    </React.Fragment>
  );
};

export default observer(CountrySelectCyclos);
